var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { ICellEditorParams } from 'ag-grid-community';
import { DwAgGridValidationEditorComponent } from './ag-grid-validation-editor';
import { FormBuilder, FormControl } from '@angular/forms';
var DwAgGridDateEditorComponent = /** @class */ (function (_super) {
    __extends(DwAgGridDateEditorComponent, _super);
    function DwAgGridDateEditorComponent(fb) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.dateFormat = 'YYYY/MM/DD';
        return _this;
    }
    DwAgGridDateEditorComponent.prototype.agInit = function (params) {
        this.editType = params.api.gridOptionsWrapper.gridOptions.editType || '';
        this.columnId = params.column.getColId();
        this.validateForm = params.form;
        this.dateFormat = params.dateFormat ? params.dateFormat : this.dateFormat;
        var currentDate = moment(params.value, this.dateFormat).toDate();
        this.formControl = new FormControl(currentDate, params.validators);
        if (!params.form) {
            this.validateForm = this.fb.group({});
        }
        this.validateForm.addControl(this.columnId, this.formControl);
        this.formControl.markAsDirty();
        _super.prototype.init.call(this);
    };
    DwAgGridDateEditorComponent.prototype.getValue = function () {
        return moment(this.formControl.value, this.dateFormat).format(this.dateFormat);
    };
    DwAgGridDateEditorComponent.prototype.afterGuiAttached = function () {
    };
    DwAgGridDateEditorComponent.prototype.focusIn = function () {
    };
    DwAgGridDateEditorComponent.prototype.focusOut = function () {
    };
    DwAgGridDateEditorComponent.prototype.isCancelAfterEnd = function () {
        return this.validationMessages.length > 0;
    };
    DwAgGridDateEditorComponent.prototype.isCancelBeforeStart = function () {
        return false;
    };
    DwAgGridDateEditorComponent.prototype.isPopup = function () {
        return false;
    };
    DwAgGridDateEditorComponent.prototype.ngOnDestroy = function () {
        this.validateForm.removeControl(this.columnId);
    };
    return DwAgGridDateEditorComponent;
}(DwAgGridValidationEditorComponent));
export { DwAgGridDateEditorComponent };
